// extracted by mini-css-extract-plugin
export default {"wrapper":"info-box-wrapper-module--wrapper--3df6e"};